var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGalaxyStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_6853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4 0.486328C13.0532 0.486328 11.3798 0.486328 9.9987 0.81789C5.61092 1.8713 2.18503 5.2972 1.13161 9.68498C0.800049 11.066 0.800049 12.7395 0.800049 16.0863V16.0863C0.800049 19.4332 0.800049 21.1066 1.13161 22.4877C2.18503 26.8755 5.61092 30.3014 9.9987 31.3548C11.3798 31.6863 13.0532 31.6863 16.4 31.6863V31.6863C19.7469 31.6863 21.4203 31.6863 22.8014 31.3548C27.1892 30.3014 30.6151 26.8755 31.6685 22.4877C32 21.1066 32 19.4332 32 16.0863V16.0863C32 12.7395 32 11.066 31.6685 9.68498C30.6151 5.2972 27.1892 1.8713 22.8014 0.81789C21.4203 0.486328 19.7469 0.486328 16.4 0.486328V0.486328Z",
    fill: "url(#paint0_angular_0_6853)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9501 11.9703L20.8859 11.6879C20.8859 9.21492 18.8734 7.20312 16.4 7.20312C13.9266 7.20312 11.9144 9.21492 11.9144 11.6879L11.8501 11.9703H8.16675L9.15959 21.2261C9.35845 23.1088 10.9462 24.5375 12.8394 24.5375H19.9606C21.8539 24.5375 23.4416 23.1088 23.6404 21.2263L24.6334 11.9703H20.9501ZM13.8001 11.9703L13.8724 11.6879C13.8724 10.2944 15.0063 9.16074 16.4 9.16074C17.7939 9.16074 18.9279 10.2944 18.9279 11.6879L19.0001 11.9703H13.8001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_0_6853",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.4 16.0863) scale(15.6)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.247168,
    stopColor: "#F4605E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31099,
    stopColor: "#E94B80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375149,
    stopColor: "#DE33A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433407,
    stopColor: "#D41AC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497701,
    stopColor: "#CB06E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528471,
    stopColor: "#C902EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563611,
    stopColor: "#CB04E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.618099,
    stopColor: "#D108D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.680263,
    stopColor: "#D80DBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.750777,
    stopColor: "#E1139E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.842513,
    stopColor: "#EC1E7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92004,
    stopColor: "#F22A65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960548,
    stopColor: "#F5355B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00124761,
    stopColor: "#F74452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.065333,
    stopColor: "#F75651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125231,
    stopColor: "#F76051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184788,
    stopColor: "#F76551"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_6853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.2,
    height: 31.2,
    fill: "white",
    transform: "translate(0.800049 0.486328)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalaxyStore);
export default __webpack_public_path__ + "static/media/GalaxyStore.4c1c56c4aee7135d8f534737f4862281.svg";
export { ForwardRef as ReactComponent };